import { useCurrentUser } from "context/UserContext";
import { Navigate, Outlet } from "react-router-dom";

const AdminRouteGuard = () => {
  const { roles } = useCurrentUser();

  if (!roles.admin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default AdminRouteGuard;
